import React, { useEffect, useState } from 'react';
import DynamicCardProfile from './DynamicCardProfile';
import CardPlaceholder from '../NFTCardPlaceholder';
import Pagination from '../../Pagination';
import { getNFTDraftsByWallet } from '../../../hooks/DraftHook';
import { getDataFromURI } from '../../../hooks/Tokenhook';
import { contractAddress } from '../../../config/BackendUrl';
import { listNFTs } from '../../../hooks/NFTHook';

const NFTDraft = () => {
  const [nfts, setNfts] = useState([]);
  const [displayedNFTs, setDisplayedNFTs] = useState([]); // NFTs for the current page
  const [lazyNFT, setLazyNFT] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit] = useState(6); // Number of items per page
  const [hasMore, setHasMore] = useState(true); // Flag for skeleton loader
  const walletAddress = localStorage.getItem('WalletAddress');
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {

    fetchNFTDrafts();

  }, []);

  useEffect(() => {
    updateDisplayedNFTs();
  }, [nfts, currentPage]);

  console.log("Draft");

  const fetchNFTDrafts = async () => {
    try {
     const Params = {
        currentPage,
        limit,
        ownerAddress: walletAddress,
        sortBy: "createdAt", // Include only if `sortBy` is defined
        draftStatus: true // Include only if `listed` is defined
      };
      const updatedNFTs = await listNFTs(Params);

      if (updatedNFTs.success) {
        setPageCount(updatedNFTs.totalPages)
        setNfts(updatedNFTs.data);
        setHasMore(false);
      } else {
        setHasMore(false); // No more NFTs
      }
    } catch (error) {
      console.error('Error fetching NFT drafts:', error);
    }
  };

  const updateDisplayedNFTs = () => {
    const startIndex = currentPage * limit;
    const endIndex = startIndex + limit;
    setDisplayedNFTs(nfts.slice(startIndex, endIndex));
  };

  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected);
  };


  return (
    <div className="row mb-30_reset">
      {displayedNFTs.length ? (
        displayedNFTs.map((nft, i) => (
          <div key={i} className="col-lg-4 col-md-6 col-sm-12 card-hover-effect">
            <DynamicCardProfile
              NFTLink={`/draftNFT/${nft._id}`}
              contractAddress={nft.contractAddress}
              mediaUrl={nft.imageUri}
              assetType={nft.assetType}
              title={nft.title}
              likes={nft.totalLikes}
              isLiked={nft.isLike}
              tokenId={nft.tokenId}
              isListed={nft.listed}
              button={true}
              buttonMessage={"draft"}
            />
          </div>
        ))
      ) : hasMore ? (
        // Display skeleton loaders
        [...Array(6)].map((_, index) => (
          <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
            <CardPlaceholder />
          </div>
        ))
      ) : (
        <h3>No Draft NFTs Available</h3>
      )}

      {pageCount > 1 && (
        <Pagination
          pageCount={pageCount}
          onPageChange={handlePageChange}
          currentPage={currentPage}
        />
       )} 
    </div>
  );
};

export default NFTDraft;
